import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
  ButtonStyled,
  InformativeSpan,
  PageTitle,
  Wrapper,
} from '../../styles';
import api from '../../../../../../services/api';
import { useAuth } from '../../../../../../hooks/auth';
import { useToast } from '../../../../../../hooks/toast';

const Finishing: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();

  const [cpf, setCpf] = useState(false);
  const [telefone, setTelefone] = useState(true);
  const [email, setEmail] = useState(false);

  async function handleSubmitCliente(): Promise<void> {
    try {
      await api.post(`/parametro`, {
        descricao: 'cliente_campos',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          telefone,
          email,
          cpf,
        }),
      });

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  }

  useEffect(() => {
    async function loadCustomerFields(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'cliente_campos',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);

          setTelefone(role.telefone);
          setEmail(role.email);
          setCpf(role.cpf);
        }
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
      }
    }

    loadCustomerFields();
  }, [user.empresa_id, addToast]);

  return (
    <Wrapper style={{ paddingLeft: 50, paddingRight: 50 }}>
      <Grid container spacing={3} style={{ marginTop: 30 }}>
        <Grid item xs={12}>
          <PageTitle>Informações obrigatórias na finalização</PageTitle>
          <InformativeSpan style={{ paddingTop: 10, maxWidth: 800 }}>
            Ao finalizar o pedido, a aplicação valida a necessidade de informar
            os seguintes dados. Selecione as informações obrigatórias no
            cadastro do cliente.
          </InformativeSpan>
          <Grid
            container
            style={{ display: 'block', paddingBottom: 60, paddingTop: 30 }}
          >
            <Grid item xs={12}>
              <Grid item lg={4} md={6} xs={12}>
                <input
                  type="checkbox"
                  name="cpf"
                  id="cpf"
                  checked={cpf}
                  onChange={(event) => setCpf(event.target.checked)}
                />
                <label
                  style={{
                    display: 'inline-block',
                    marginBottom: 5,
                    marginLeft: 10,
                  }}
                  htmlFor="cpf"
                >
                  CPF/CNPJ
                </label>
              </Grid>
              <Grid item lg={4} md={6} xs={12}>
                <input
                  type="checkbox"
                  name="telefone"
                  id="telefone"
                  checked={telefone}
                  onChange={(event) => setTelefone(event.target.checked)}
                />
                <label
                  style={{
                    display: 'inline-block',
                    marginBottom: 5,
                    marginLeft: 10,
                  }}
                  htmlFor="telefone"
                >
                  Telefone
                </label>
              </Grid>
              <Grid item lg={4} md={6} xs={12}>
                <input
                  type="checkbox"
                  name="email"
                  id="email"
                  checked={email}
                  onChange={(event) => setEmail(event.target.checked)}
                />
                <label
                  style={{
                    display: 'inline-block',
                    marginBottom: 5,
                    marginLeft: 10,
                  }}
                  htmlFor="email"
                >
                  E-mail
                </label>
              </Grid>
              <Grid container justify="center" style={{ paddingTop: 30 }}>
                <Grid item lg={4} md={6} xs={12}>
                  <ButtonStyled type="button" onClick={handleSubmitCliente}>
                    Salvar
                  </ButtonStyled>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default Finishing;
